import validate from "/home/vsts/work/1/s/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import app_45version_45check_45global from "/home/vsts/work/1/s/frontend/middleware/appVersionCheck.global.ts";
import manifest_45route_45rule from "/home/vsts/work/1/s/frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  app_45version_45check_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "analytics-job": () => import("/home/vsts/work/1/s/frontend/middleware/analyticsJob.ts"),
  auth: () => import("/home/vsts/work/1/s/frontend/middleware/auth.ts"),
  "page-view-tracking": () => import("/home/vsts/work/1/s/frontend/middleware/pageViewTracking.ts"),
  "shared-link": () => import("/home/vsts/work/1/s/frontend/middleware/sharedLink.ts")
}